import { z } from 'zod/v4';

/**
 * Per-device visibility flags shared by every zero-block (and most default)
 * widget data schemas. Form twin: `visibilityPlugin` in
 * `@sites/entity-signal-form` (`plugins/widget/visibility.plugin.ts`).
 *
 * Exposed as a plain **shape** (not a `z.object`) so widget data schemas
 * spread it into their own object alongside widget-specific keys:
 * `z.object({ ...visibilityPluginShapeLegacy, figure: figureShapeSchema, … })`.
 */
export const visibilityPluginShapeLegacy = {
    hideOnDesktop: z.boolean(),
    hideOnTablet: z.boolean(),
    hideOnMobile: z.boolean(),
} as const;
